<template>
  <a-spin :spinning="spinning">
    <div class="vote-edit">
      <a-row v-if="voteType === 1" :gutter="gutter">
        <a-col :span="4" class="vote-item-name"><span class="star">*</span>Vote日期：</a-col>
        <a-col :span="20" class="vote-item-value">
          <a-date-picker v-model="date" :allowClear="false" />
        </a-col>
      </a-row>
      <a-row :gutter="gutter">
        <a-col :span="4" class="vote-item-name"><span class="star">*</span>Vote名称：</a-col>
        <a-col :span="20" class="vote-item-value"><a-input class="w-410" v-model="oVoteInfo.name" placeholder="请填写"/></a-col>
      </a-row>
      <a-row :gutter="gutter">
        <a-col :span="4" class="vote-item-name">
          Vote观点：
        </a-col>
        <!-- 导入飞书表格 -->
        <a-col :span="20" class="vote-item-value">
          <a-radio-group v-model="isLink" :options="options" class="link-radio" />
          <div v-if="!isLink">
            <div v-for="(item, index) in viewPoint" class="vote-view-container" :key="index">
              <div class="vote-view-section-1">
                <select-member
                  :userlist="item.userId !== undefined ? [{ id: item.userId, nickname: item.nickname }] : []"
                  :multi-choose="false"
                  :parentIndex="0"
                  class="select"
                  :canEdit="true"
                  :width="'auto'"
                  :abridged="5"
                  :canExpand="true"
                  @delChosenUser="
                    user => {
                      delUserIds(user, index);
                    }
                  "
                  @chose="
                    user => {
                      choseUserIds(user, index);
                    }
                  "
                />
                <a-radio-group v-model="item.point" @change="pointChange(item)">
                  <a-radio :value="1"> 正面 </a-radio>
                  <a-radio :value="-1"> 负面 </a-radio>
                  <a-radio :value="0"> 弃权 </a-radio>
                </a-radio-group>
                <a-switch checked-children="有效" un-checked-children="无效" default-checked class="gap-10" v-model="item.isEffective" />
                <a-button size="small" shape="circle" icon="close" ghost type="danger" @click="delViewPoint(index)" class="gap-10" />
              </div>
              <div>
                <!--                <a-select class="score" placeholder="分数" allowClear v-model="item.score" :disabled="item.point === 0">-->
                <!--                  <a-select-option v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="i" :value="i">{{ i }}</a-select-option>-->
                <!--                </a-select>-->
                <a-input-number
                  class="score"
                  v-model="item.score"
                  :min="-10"
                  :max="10"
                  :step="0.1"
                  :precision="1"
                  :disabled="item.point === 0"
                  :placeholder="'分数'"
                  style="width: 100px;"
                />
                <a-input class="reason" placeholder="请填写vote说明" v-model="item.reason"></a-input>
              </div>
            </div>
            <div class="add" @click="addViewPoint">
              {{ '+  添加Vote记录' }}
            </div>
          </div>
          <div v-else-if="!oVoteInfo.urlName">
            <a-spin tip="Loading..." :spinning="feishuLinkLoading">
              <a-input class="w-410" placeholder="请输入Vote飞书表格URL" v-model="oVoteInfo.url"></a-input>
              <a-button type="primary" class="m-l-12" @click="showConfirm">点击绑定</a-button>
            </a-spin>
          </div>
          <div v-else>
            已绑定飞书Vote表格:<a @click="openFeishuLink"><a-icon type="file" class="url-icon" />{{ oVoteInfo.urlName }}</a>
            <a-popconfirm title="确认解除绑定?" ok-text="确认" cancel-text="取消" @confirm="unbindFeishuLink">
              <a-button type="link">解除绑定</a-button>
            </a-popconfirm>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="gutter">
        <a-col :span="4" class="vote-item-name">Vote目的：</a-col>
        <a-col :span="20" class="vote-item-value">
          <a-auto-complete
            class="w-410"
            placeholder="请选择"
            v-model="oVoteInfo.goal"
            :data-source="['CEO Meeting', 'TS vote', '交割vote', '其它vote']"
            :filter-option="(input, option) => option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0"
        /></a-col>
      </a-row>
      <a-row :gutter="gutter">
        <a-col :span="4" class="vote-item-name">Vote算法：</a-col>
        <a-col :span="20" class="vote-item-value">
          <a-auto-complete
            class="w-410"
            placeholder="请选择"
            v-model="oVoteInfo.method"
            :data-source="['2名IC；1名IC+1名(S)ICa；3名(S)ICa', '2名IC；1名IC+2名(S)ICa', '1名IC+2名(S)ICa']"
            :filter-option="(input, option) => option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0"
        /></a-col>
      </a-row>

      <a-row :gutter="gutter" v-if="isLink">
        <a-col :span="4" class="vote-item-name">观点有效IC：</a-col>
        <a-col :span="20" class="vote-item-value">
          <!-- select -->
          <a-select mode="multiple" placeholder="请选择IC" class="w-410" @change="handleICChange" :default-value="icListValue" :filterOption="filterOption">
            <a-select-option v-for="i in icList" :key="i.id">
              {{ i.nickname }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="gutter">
        <a-col :span="4" class="vote-item-name"><span class="star">*</span>投资金额：</a-col>
        <a-col :span="20" class="vote-item-value">
          <a-textarea placeholder="请输入投资金额" v-model="oVoteInfo.investmentRecord" :auto-size="{ minRows: 6 }" />
        </a-col>
      </a-row>
      <a-row v-if="voteInfo.isEdit">
        <a-col :span="8">
          <a-button size="small" @click="cancel()">取消</a-button>
          <a-button size="small" type="primary" @click="submit()" class="m-l-12">保存</a-button>
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>
<style lang="less" scoped>
.vote-edit {
  .vote-item-name {
    line-height: 32px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    max-width: 105px;
  }
  .vote-item-value {
    flex: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    .link-radio {
      padding: 6px 4px 12px 4px;
    }
    .select {
      min-width: 92px;
      margin-right: 15px;
    }
    .score {
      width: 80px;
    }
    .reason {
      margin-left: 16px;
      margin-top: 5px;
      width: 350px;
    }
  }
  .vote-view-section-1 {
    display: flex;
    align-items: center;
  }
  .vote-view-container {
    padding: 5px 0;
    margin-bottom: 10px;
  }
  .w-410 {
    width: 410px;
  }
  .m-l-12 {
    margin-left: 12px;
  }
  .url-icon {
    margin: 0 4px 0 12px;
  }
}
.star {
  color: #ff4d4f;
  margin-right: 4px;
}
.add {
  height: 40px;
  min-width: 300px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
  color: #999;
  border-radius: 4px;
  border: 1px dashed #d9d9d9;
  background-color: #fafafa;
  transition: all 0.3s ease;
}
</style>

<script>
import SelectMember from '@/components/project/selectMember.vue';
import moment from 'moment';
import { queryFeishuDocInfo } from '@/api/meeting';
import { askVote } from '@/api/projectVote';

export default {
  components: {
    SelectMember
  },
  props: {
    voteType: {
      type: Number,
      default() {
        return 0; // 0: 会议详情页, 1: vote列表页
      }
    },
    voteInfo: {
      type: Object,
      default() {
        return {
          id: undefined,
          name: '',
          viewPoint: [],
          method: '',
          investmentRecord: '',
          'averageScore:': -1
        };
      }
    },
    defaultName: {
      type: String,
      default: ''
    },
    defaultViewPoint: {
      type: Array,
      default() {
        return [
          // {
          //   id: 12,
          //   nickname: 'laocao'
          // }
        ];
      }
    },
    defaultInvestmentRecord: {
      type: String,
      default: '本轮投融资记录:\n\n历史投融资记录:\n\n'
    },
    icList: {
      type: Array,
      default() {
        return [];
      }
    },
    companyId: Number,
    meetingProjectId: Number
  },
  data() {
    return {
      spinning: false,
      feishuLinkLoading: false,
      moment,
      oVoteInfo: {
        id: undefined,
        name: '',
        method: '',
        investmentRecord: '',
        'averageScore:': -1,
        url: '',
        urlName: '',
        goal: ''
      },
      options: [
        { label: '手动录入', value: false },
        { label: '绑定飞书Vote表格', value: true }
      ],
      isLink: false, // 绑定飞书表格
      isLinkReady: false, // 已绑定飞书表格
      viewPoint: [
        // {
        //   id: 12,
        //   nickname: 'laocao',
        //   score: 10,
        //   point: 1,
        //   reason: 'zheshi vote guandian',
        //   isEffective: 1
        // }
      ],
      gutter: [8, 24], // 栅格间隔
      icListValue: [],
      date: moment()
    };
  },
  watch: {
    icList: {
      handler(val) {
        // 如果voteInfo没有填充icList的话,就用全部icList
        this.icListValue = this.icListValue.length === 0 && val && val.length > 0 ? val.map(_ => _.id) : this.icListValue;
      },
      immediate: true
    },
    voteInfo: {
      handler(val) {
        Object.keys(this.oVoteInfo).forEach(key => {
          this.oVoteInfo[key] = this.voteInfo[key];
        });
        this.oVoteInfo.name = this.oVoteInfo.name || this.defaultName;
        this.oVoteInfo.investmentRecord = this.oVoteInfo.investmentRecord || this.defaultInvestmentRecord;
        this.isLink = this.oVoteInfo && this.oVoteInfo.url ? true : false;
        // 如果有url,isLinkReady值为true,考虑effectiveIds为空的情况
        // 如果没有url,就初始化为全量ic
        if (this.voteInfo.url) {
          this.icListValue = this.voteInfo.effectiveIds ? this.voteInfo.effectiveIds.split(',').map(Number) : [];
          this.isLinkReady = true;
        } else {
          this.icListValue = this.icList.map(_ => _.id);
        }
        if (this.voteInfo.date) {
          this.date = moment.unix(this.voteInfo.date);
        }
        // 编辑vote,填充原有vote观点
        if (this.voteInfo && this.voteInfo.viewPoint) {
          this.viewPoint = this.voteInfo.viewPoint.map(i => {
            return {
              ...i,
              isEffective: i.isEffective === 0
            };
          });
        }
        // 如果是新建vote的话,填充默认vote(参会的ic)
        if (this.viewPoint.length === 0) {
          this.viewPoint = this.defaultViewPoint.map(i => {
            return {
              ...i,
              score: undefined,
              reason: '',
              isEffective: true
            };
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleICChange(value) {
      this.icListValue = value;
    },
    showConfirm() {
      // 如果viewpoint有值,就弹提示框,没有就不弹
      if (this.viewPoint.length > 0) {
        let _this = this;
        this.$confirm({
          title: '确认要导入该飞书表格吗?',
          content: h => <div>绑定飞书表格后,已填写的Vote观点内容将被Vote飞书表格中的内容替换.</div>,
          okText: '确认',
          cancelText: '取消',
          onOk() {
            _this.bindFeishuLink();
          },
          onCancel() {},
          class: 'test'
        });
      } else {
        this.bindFeishuLink();
      }
    },
    async bindFeishuLink() {
      this.oVoteInfo.urlName = await this.geturlName();
    },
    unbindFeishuLink() {
      this.oVoteInfo.urlName = '';
      this.oVoteInfo.url = '';
      this.isLinkReady = false;
    },
    openFeishuLink() {
      window.open(this.oVoteInfo.url);
    },
    choseUserIds(user, index) {
      console.log(user);
      this.viewPoint[index].userId = user[0].id;
      this.viewPoint[index].nickname = user[0].nickname;
    },
    delUserIds(user, index) {
      this.viewPoint[index].userId = undefined;
      this.viewPoint[index].nickname = undefined;
    },
    delViewPoint(index) {
      this.viewPoint.splice(index, 1);
    },
    addViewPoint() {
      this.viewPoint.push({
        userId: undefined,
        nickname: '',
        score: undefined,
        point: undefined,
        reason: '',
        isEffective: true
      });
    },
    pointChange(item) {
      // 弃权默认传0分
      if (item.point === 0) {
        item.score = 0;
      } else {
        item.score = undefined;
      }
    },
    filterOption(input, option) {
      console.log(option);
      return option.componentOptions.children[0].text.indexOf(input) >= 0;
    },
    async geturlName() {
      this.feishuLinkLoading = true;
      let res = await queryFeishuDocInfo(this.oVoteInfo.url);
      this.feishuLinkLoading = false;
      if (res.code === 200) {
        this.isLinkReady = true;
        return res.data.name;
      } else {
        return '';
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    fail(text) {
      this.$message.error(text);
      this.$emit('fail');
    },
    submit() {
      if (this.oVoteInfo.name === '') {
        this.fail('请输入Vote名称');
        return;
      }

      if (!this.isLink && this.viewPoint.length !== 0) {
        let index = this.viewPoint.findIndex(i => {
          return i.userId && i.point === undefined;
        });
        if (index >= 0) {
          this.fail('请选择观点');
          return;
        }
        index = this.viewPoint.findIndex(i => !i.userId);
        if (index >= 0) {
          this.fail('请选择投票人');
          return;
        }
      }

      if (this.isLink && !this.isLinkReady) {
        this.fail('请绑定飞书表格链接');
        return;
      }

      let viewPoint = this.viewPoint.filter(i => i.userId !== undefined).map(i => ({ ...i, isEffective: i.isEffective ? 0 : -1 }));
      let res = { ...this.oVoteInfo, viewPoint: viewPoint };
      // 传id是绑定会议的vote, 传date是新建不关联会议的vote
      if (this.voteType === 0) {
        delete res.date;
      } else {
        delete res.id;
        res.date = this.date.unix();
      }
      // 如果isLink就删掉viewPoint,如果没有就删掉url和urlName
      if (this.isLink) {
        delete res.viewPoint;
        if (this.icListValue.length > 0) {
          res['effectiveIds'] = this.icListValue.join(',');
        } else {
          res['effectiveIds'] = '';
        }
      } else {
        delete res.url;
        delete res.urlName;
        delete res.effectiveIds;
      }
      console.log('res', res);
      this.askVote(res);
    },
    async askVote(value) {
      try {
        this.spinning = true;
        let info = {
          ...value,
          companyId: this.companyId,
          meetingProjectId: this.meetingProjectId ? this.meetingProjectId : undefined
        };
        if (this.voteInfo.id) {
          info['id'] = this.voteInfo.id;
        }

        let res = await askVote(info);
        this.spinning = false;

        if (res.code === 200) {
          this.$message.success('保存成功');
          this.$emit('refresh');
        }
      } catch (error) {
        this.$message.error('保存失败');
        this.spinning = false;
        console.log(error);
      }
    }
  }
};
</script>
